export enum ShippingCompany{
    ups = 'ups',
    fedex = 'fedex',
    canadapost = 'canadapost'
}